/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Save_SeatingInputs */



/**
* | output |
* | --- |
* | "Save seating" |
*
* @param {Rounds_Save_SeatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_save_seating = /** @type {((inputs?: Rounds_Save_SeatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Save_SeatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le placement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar asientos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvar assentos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva posti")
	return /** @type {LocalizedString} */ ("Save seating")
});